const ITEMS = [
  "PLANIFOLIA GRADE A",
  "TAHITENSIS BEANS",
  "EXTRACTION GRADE C",
  "PURE VANILLA POWDER",
  "MOISTURE 30–35%",
  "INDONESIAN ORIGIN",
  "GLOBAL AIR FREIGHT",
  "FLEXIBLE 1 KG MOQ",
];

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="bg-[#2E4F3E] text-[#FDFBF7] py-4 border-y border-[#1B3B2B] overflow-hidden"
    aria-hidden="true"
  >
    <div className="flex whitespace-nowrap animate-marquee will-change-transform">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex shrink-0">
          {ITEMS.map((t) => (
            <span key={`${copy}-${t}`} className="flex items-center font-mono text-xs sm:text-sm tracking-[0.25em]">
              <span className="mx-7">{t}</span>
              <span className="text-[#D4A359]">•</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
